<div [ngClass]="optionsValue().cssClasses.pagingContainer">
    <div [ngClass]="optionsValue().cssClasses.pagingElement">
        <a (click)="setPage(1)" [ngClass]="{disabled: isFirst()}">
            <span [ngClass]="optionsValue().cssClasses.firstItemElement"></span>
        </a>

        <a (click)="setPage((pageValue() ?? 1) - 1)" [ngClass]="{disabled: isFirst()}">
            <span [ngClass]="optionsValue().cssClasses.previousItemElement"></span>
        </a>

        <a (click)="setPage((pageValue() ?? 1) + 1)" [ngClass]="{disabled: isLast()}">
            <span [ngClass]="optionsValue().cssClasses.nextItemElement"></span>
        </a>
    </div>

    <div [ngClass]="optionsValue().cssClasses.pagingSeparatorElement"></div>

    @if(itemsPerPageItems().length)
    {
        <div [ngClass]="optionsValue().cssClasses.itemsPerPageElement">
            @for (itemsPerPage of itemsPerPageItems(); track itemsPerPage)
            {
                <a (click)="setItemsPerPage(itemsPerPage.value)" [ngClass]="{active: itemsPerPage.isActive}">
                    <span [innerHtml]="itemsPerPage.value | infinityNaN"></span>
                </a>
            }
        </div>
    }
</div>